import { getAxiosInstance } from '../api.client';
import { DateOnly, DateOnlySchema } from '../common/common.models';
import {
    type ExternalCostAggregate,
    type ExternalCostEntry,
    type ExternalCostEntryFormModel,
} from './externalCostEntries.models';

export async function getExternalCostEntries(
    projectId: string,
    externalTaskId: string,
): Promise<ExternalCostEntry[]> {
    const response = await getAxiosInstance().get<ExternalCostEntry[]>(
        `/project/${projectId}/external-task/${externalTaskId}/external-cost-entry`,
    );
    return response.data;
}

export async function getExternalCostEntryById(
    projectId: string,
    externalTaskId: string,
    id: string,
): Promise<ExternalCostEntry> {
    const response = await getAxiosInstance().get<ExternalCostEntry>(
        `/project/${projectId}/external-task/${externalTaskId}/external-cost-entry/${id}`,
    );
    return response.data;
}

export async function createExternalCostEntry(
    projectId: string,
    externalTaskId: string,
    data: ExternalCostEntryFormModel,
): Promise<ExternalCostEntry> {
    const response = await getAxiosInstance().postForm<ExternalCostEntry>(
        `/project/${projectId}/external-task/${externalTaskId}/external-cost-entry`,
        data,
    );
    return response.data;
}

export async function updateExternalCostEntry(
    projectId: string,
    externalTaskId: string,
    id: string,
    data: ExternalCostEntryFormModel,
): Promise<ExternalCostEntry> {
    const response = await getAxiosInstance().putForm<ExternalCostEntry>(
        `/project/${projectId}/external-task/${externalTaskId}/external-cost-entry/${id}`,
        data,
    );
    return response.data;
}

export async function deleteExternalCostEntry(
    projectId: string,
    externalTaskId: string,
    id: string,
): Promise<void> {
    await getAxiosInstance().delete(
        `/project/${projectId}/external-task/${externalTaskId}/external-cost-entry/${id}`,
    );
}

export async function getExternalCostEntryDates(
    projectId: string,
    startDate: DateOnly,
    endDate: DateOnly,
): Promise<string[]> {
    const isValid =
        DateOnlySchema.safeParse(startDate).success &&
        DateOnlySchema.safeParse(endDate).success;
    if (!isValid) {
        throw new Error('Invalid date range');
    }

    const response = await getAxiosInstance().get<string[]>(
        `/project/${projectId}/external-cost-entry-dates`,
        {
            params: {
                startDate,
                endDate,
            },
        },
    );
    return response.data;
}

export async function getExternalCostEntriesByDate(
    projectId: string,
    date: DateOnly,
): Promise<ExternalCostAggregate[]> {
    const isValid = DateOnlySchema.safeParse(date).success;
    if (!isValid) {
        throw new Error('Invalid date');
    }

    const response = await getAxiosInstance().get<ExternalCostAggregate[]>(
        `/project/${projectId}/external-cost-entries-by-date`,
        {
            params: {
                date,
            },
        },
    );
    return response.data;
}
